import { Injectable } from '@angular/core';
import { locale as english } from '../i18n/Englisch';
import { locale as german } from '../i18n/Deutsch';
import { locale as russian } from '../i18n/Russisch';
import { locale as portugese } from '../i18n/Portugiesisch';
import { locale as danish } from '../i18n/Daenisch';
import { locale as ukrain } from '../i18n/Ukrainisch';
import { locale as dutch } from '../i18n/Niederlaendisch';
import { locale as polish } from '../i18n/Polnisch';
import { locale as czech } from '../i18n/Tschechisch';
import { locale as spanish } from '../i18n/Spanisch';
import { locale as italian } from '../i18n/Italienisch';
import localeDe from '@angular/common/locales/de';
import localeUs from '@angular/common/locales/en';
import localeEn from '@angular/common/locales/en-GB';
import localeRu from '@angular/common/locales/ru';
import localePt from '@angular/common/locales/pt';
import localeDa from '@angular/common/locales/da';
import localeUk from '@angular/common/locales/uk';
import localeNl from '@angular/common/locales/nl';
import localePl from '@angular/common/locales/pl';
import localeCs from '@angular/common/locales/cs';
import localeEs from '@angular/common/locales/es';
import localeIt from '@angular/common/locales/it';
import { EmployerService } from './employer.service';
import { registerLocaleData, DecimalPipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { NGXLogger } from 'ngx-logger';
import { FuseTranslationLoaderService } from '../services/translation-loader.service';

@Injectable()
export class BootstrapService {
  className = 'BootstrapService';

  userLanguage = null;
  employerLanguage = null;

  constructor(
    private translationLoader: FuseTranslationLoaderService,
    private translate: TranslateService,
    private employerService: EmployerService,
    private log: NGXLogger
  ) {
    this.log.debug(this.className + ': construct');

    // this.handleWhitelabelStuff();

    this.initLanguages();

    this.employerService.onGetEmployerConfig().subscribe((employerConfig) => {
      this.employerLanguage = null;
      if (employerConfig && employerConfig.language) {
        this.employerLanguage = employerConfig.language;
        this.decideOnLanguageAndSwitch();
      }
    });
  }

  initLanguages() {
    // Add languages
    this.translate.addLangs(['en', 'de', 'ru', 'pt', 'da', 'uk', 'nl', 'pl', 'cs', 'es', 'it']);

    // Set the default language
    this.translate.setDefaultLang('en');

    // Set language for exa app
    this.translationLoader.loadTranslations(english, german, russian, portugese, danish, ukrain, dutch, polish, czech, spanish, italian);

    const browserLanguage = this.translate.getBrowserLang();
    this.log.debug('Browser language: ' + browserLanguage);
    this.switchLanguage(browserLanguage);
  }

  decideOnLanguageAndSwitch() {
    let lang = this.translate.getBrowserLang();
    if (this.userLanguage) {
      lang = this.userLanguage;
    } else if (this.employerLanguage) {
      lang = this.employerLanguage;
    }
    this.switchLanguage(lang);
  }

  switchLanguage(language: string) {
    let selectedLanguage = 'en';
    switch (language) {
      case 'de':
        // Set Language for format number
        registerLocaleData(localeDe);
        this.translate.use('de');
        selectedLanguage = language;
        break;
      case 'en':
        if (this.translate.getBrowserCultureLang() == 'en-EN') {
          registerLocaleData(localeEn);
          selectedLanguage = 'en';
        } else {
          registerLocaleData(localeUs);
          selectedLanguage = 'en (us)';
        }
        this.translate.use('en');
        break;
      case 'ru':
        // Set Language for format number
        registerLocaleData(localeRu);
        this.translate.use('ru');
        selectedLanguage = language;
        break;
      case 'pt':
        // Set Language for format number
        registerLocaleData(localePt);
        this.translate.use('pt');
        selectedLanguage = language;
        break;
      case 'da':
        // Set Language for format number
        registerLocaleData(localeDa);
        this.translate.use('da');
        selectedLanguage = language;
        break;
      case 'uk':
        // Set Language for format number
        registerLocaleData(localeUk);
        this.translate.use('uk');
        selectedLanguage = language;
        break;
      case 'nl':
        // Set Language for format number
        registerLocaleData(localeNl);
        this.translate.use('nl');
        selectedLanguage = language;
        break;
      case 'pl':
        // Set Language for format number
        registerLocaleData(localePl);
        this.translate.use('pl');
        selectedLanguage = language;
        break;
      case 'cs':
        // Set Language for format number
        registerLocaleData(localeCs);
        this.translate.use('cs');
        selectedLanguage = language;
        break;
      case 'es':
        // Set Language for format number
        registerLocaleData(localeEs);
        this.translate.use('es');
        selectedLanguage = language;
        break;
      case 'it':
        // Set Language for format number
        registerLocaleData(localeIt);
        this.translate.use('it');
        selectedLanguage = language;
        break;
      default:
        registerLocaleData(localeDe);
        this.translate.use('en');
        selectedLanguage = 'en';
        this.log.debug('Selected language not supported');
        break;
    }
    this.log.debug('Selected language: ' + selectedLanguage);
  }

  /**
   * Diese Methode muss aufgerufen werden von Main Component, damit Exa Module richtig initializiert werden kann
   */
  public init() {
    // Dummy, die Initialisierung passiert im constructor
  }
}
